/*
 * Footer language and country control (snippets/footer-localization.liquid).
 *
 * The trigger opens a modal dialog holding one localization form with Ship to and Language, so both change with
 * one submit. The form posts natively; this script only opens and closes the dialog, sorts countries in the page
 * language, puts unsaved choices back when the dialog closes, and shows the duties footnote for the duties country.
 */

class FooterLocalization extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog')
    this.trigger = this.querySelector('[data-open]')
    this.form = this.dialog?.querySelector('form')
    this.countrySelect = this.dialog?.querySelector('select[name="country_code"]')
    this.footnote = this.dialog?.querySelector('[data-footnote]')
    this.dutiesCountry = this.dataset.dutiesCountry

    if (!this.dialog || !this.trigger || !this.form) return

    this.sortCountries()

    this.trigger.addEventListener('click', () => this.open())
    this.querySelectorAll('[data-close]').forEach(button => {
      button.addEventListener('click', () => this.dialog.close())
    })
    this.dialog.addEventListener('click', event => {
      if (event.target === this.dialog) this.dialog.close()
    })
    this.dialog.addEventListener('close', () => this.onClose())
    this.form.addEventListener('submit', () => (this.submitting = true))
    this.countrySelect?.addEventListener('change', () => this.updateFootnote())
  }

  open() {
    if (this.dialog.open) return
    this.dialog.showModal()
    document.documentElement.classList.add('footer-localization-open')
  }

  onClose() {
    document.documentElement.classList.remove('footer-localization-open')
    if (!this.submitting) {
      this.form.reset()
      this.updateFootnote()
    }
    if (document.activeElement === document.body || this.dialog.contains(document.activeElement)) {
      this.trigger.focus()
    }
  }

  updateFootnote() {
    if (!this.footnote || !this.countrySelect) return
    this.footnote.hidden = this.countrySelect.value !== this.dutiesCountry
  }

  sortCountries() {
    if (!this.countrySelect) return
    let collator
    try {
      collator = new Intl.Collator(document.documentElement.lang || undefined, { sensitivity: 'base' })
    } catch (error) {
      collator = new Intl.Collator()
    }
    const selected = this.countrySelect.value
    const options = Array.from(this.countrySelect.options)
    options.sort((a, b) => collator.compare(a.textContent.trim(), b.textContent.trim()))
    this.countrySelect.append(...options)
    this.countrySelect.value = selected
  }
}

if (!customElements.get('footer-localization')) {
  customElements.define('footer-localization', FooterLocalization)
}
